import React, { Component } from 'react';
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { toastError, countryActionId, cityActionId, industryActionId, stateActionId, downloadReport, toastSuccess, sessionExpireMessage, tokenInavlidMessage } from '../../../utils/constants'
import { fill_action } from '../../../actions/fillCombo_action'
import Pagination from "../../../utils/pagination";
import Header from '../../../common_components/Header';
import { get_roleList_action, delete_role_action } from '../../../actions/adminAction/role_action';
import moment from 'moment';
import Loader from '../../../utils/Loader';

class roleList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false, isFilterShow: false,
            RoleID: '', currentPage: 1, RoleList: [], recordsPerPage: 10,
            ProformaInvoiceDate: '', RoleName: '', CompanyName: '',
            FullAccess: false, ReadAccess: false, WriteAccess: false, UpdateAccess: false, DeleteAccess: false, DownloadAccess: false, Is_SpecialAccess: false, SendAccess: false
        }
        this.updateItem = this.updateItem.bind(this);
        this.updateRecordsPerPage = this.updateRecordsPerPage.bind(this);
    }
    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("loginDataSS")) == null) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
            return;
        }

        window.scrollTo(0, 0);
        const loginAccessList = JSON.parse(sessionStorage.getItem('loginAccesslist')) || [];
        const proformaListModule = loginAccessList.find(module => module.ModuleName === "Role List");

        if (proformaListModule) {
            const { FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = proformaListModule;

            if (!FullAccess && !ReadAccess) {
                this.props.navigate('/login'); // Navigate to login if no access
            } else {
                this.setState({
                    FullAccess: !!FullAccess,
                    ReadAccess: !!ReadAccess,
                    WriteAccess: !!WriteAccess,
                    UpdateAccess: !!UpdateAccess,
                    DeleteAccess: !!DeleteAccess,
                    DownloadAccess: !!DownloadAccess,
                    Is_SpecialAccess: !!Is_SpecialAccess,
                    SendAccess: !!SendAccess
                });

                if (FullAccess) {
                    this.setState({
                        ReadAccess: true,
                        WriteAccess: true,
                        UpdateAccess: true,
                        DeleteAccess: true,
                        DownloadAccess: true,
                        Is_SpecialAccess: true,
                        SendAccess: true
                    });
                }
            }
        } else {
            this.props.navigate('/login');
        }

        if (loginAccessList.length) {
            // this.getFillList(countryActionId, '', '', '', '').then(() => {
            this.getRoleList();
        }
        // });
    }


    getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
        this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
                .then((data) => {
                    if (data.error != 1) {
                        // if (actionID === countryActionId) {
                        //     this.setState({ countryList: data.data })
                        //     resolve(true)
                        // }

                    }
                })
        })
    }

    getRoleList() {
        const { isLoading, CompanyName, ProformaInvoiceDate, RoleName } = this.state
        this.setState({ isLoading: true })
        this.props
            .get_roleList_action(CompanyName, ProformaInvoiceDate, RoleName)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ RoleList: data.data });
                    setTimeout(() => {
                        this.setState({ isLoading: false });
                    }, 500);
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    clearFilter() {
        this.setState({ RoleName: '' }, () => this.getRoleList())
    }
    navigateRole(RoleID) {
        this.props.navigate('/role_details', { state: { RoleID: RoleID } })
    }
    updateItem(item) {
        this.setState({ currentPage: item });
    }
    updateRecordsPerPage = (count) => {
        this.setState({ recordsPerPage: count, currentPage: 1 }, () => window.scrollTo(0, 0));
    };
    roleRecord(RoleList) {
        return (
            <table className="table table-bordered table-striped mg-b-0">
                <thead>
                    <tr>
                        <th>Role Name</th>
                        <th>Status</th>
                        <th className="text-right" style={{ width: "10%" }} />
                    </tr>
                </thead>
                <tbody id="myTable">
                    {RoleList.length > 0 ? RoleList.map((data, i) => (
                        <tr>
                            <td>{data.RoleName}</td>
                            <td>{data.IsActive == true ? 'Active' : 'InActive'}</td>
                            <td className="text-center" style={{ width: '5%' }}>
                                <a
                                    // href="javascript:void(0);"
                                    onClick={(e) => this.navigateRole(data.RoleID)}
                                    title="Edit Role"
                                    className="load_document_icon mx-2"
                                    data-toggle="modal"
                                    data-target="#add_comment_modal"
                                >
                                    <i className="fa fa-edit" />
                                </a>
                                <a
                                    // href="javascript:void(0);"
                                    onClick={(e) => this.deleteRole(data.RoleID)}
                                    title="Delete Role"
                                    className="load_document_icon mx-2"
                                    data-toggle="modal"
                                    data-target="#add_comment_modal"
                                >
                                    <i className="fa fa-trash" />
                                </a>
                            </td>

                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={12}> No Record Found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    toggleFilterCollapse() {
        this.setState((prevstate) => ({
            isFilterShow: !prevstate.isFilterShow
        }))
    }
    deleteRole(RoleID) {
        this.setState({ isLoading: true })
        this.props
            .delete_role_action(RoleID)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess('Role Deleted Successfully')
                    setTimeout(() => {
                        this.setState({ isLoading: false });
                        this.getRoleList()
                    }, 500);
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    render() {
        const { isLoading, CompanyName, currentPage, RoleList, isFilterShow,
            ProformaInvoiceDate, RoleName, recordsPerPage,
            FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = this.state
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        const currentRecords = RoleList.slice(
            indexOfFirstRecord,
            indexOfLastRecord
        );
        const nPages = Math.ceil(RoleList.length / recordsPerPage);
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                    // <></>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />
                <ToastContainer />
                <section class="registration_form">
                    <div class="container">
                        <div class="row mt-15">
                            <section className="table_section">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-lg-12">
                                            <div className="card shadow-none border mb-2" >
                                                <div className="card-header py-2">
                                                    <h6 className='pt-2' style={{ float: 'left' }}>Role List</h6>
                                                    {(JSON.parse(sessionStorage.getItem('loginDataSS'))?.RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS'))?.RoleName == 'Admin') ? <>
                                                        <a style={{ float: 'right' }}
                                                            href="javascript:void(0);"
                                                            className="btn btn-purple custom_btn"
                                                            title="Filter"
                                                            data-toggle="modal"
                                                            data-target="#filter_modal"
                                                            onClick={() => this.toggleFilterCollapse()}
                                                        >
                                                            <i className="fa fa-filter" />
                                                        </a>
                                                        <a style={{ float: 'right' }}
                                                            href="javascript:void(0);"
                                                            title="Add Role"
                                                            onClick={() => this.navigateRole(null)}
                                                            className="load_document_icon  p-1 px-2 send_credentials-btn mx-1"
                                                            data-toggle="modal"
                                                            data-target="#add_comment_modal"
                                                        >
                                                            Add
                                                        </a>

                                                    </> : <></>}
                                                </div>
                                                <ul className="list-group list-group-flush" >
                                                    {isFilterShow && <>

                                                        <li className="list-group-item"><div className="row">
                                                            <div class="col-md-3">
                                                                <div class="form-group">
                                                                    <label>Role Name<span className="red-star text-danger">*</span></label>
                                                                    <input type="text" class="form-control" placeholder="Enter Role Name" value={RoleName} onChange={(e) => this.setState({ RoleName: e.target.value })} maxLength={1000} />

                                                                </div>
                                                            </div>
                                                            <div className="col-xl-2 mb-3">
                                                                < button style={{ marginTop: '20px' }} className='btn btn-primary mr-2' onClick={() => this.getRoleList()}>
                                                                    Search
                                                                </button>
                                                                <button type="button" style={{ marginTop: '20px' }} className='btn btn-dark mr-2 ms-2' onClick={e => this.clearFilter()}>
                                                                    Clear
                                                                </button>
                                                            </div>
                                                        </div></li>
                                                    </>}
                                                </ul>
                                            </div>

                                            <div className="card shadow-none border">
                                                <div className="card-body p-2 pb-0">

                                                    <div className="custom_table">
                                                        <div className="hack1">
                                                            <div className="hack2">
                                                                {this.roleRecord(currentRecords)}
                                                                {RoleList.length > 0 ? (
                                                                    <Pagination
                                                                        nPages={nPages}
                                                                        currentPage={currentPage}
                                                                        setCurrentPage={this.updateItem}
                                                                        totalRecords={RoleList.length}
                                                                        pageLength={recordsPerPage}
                                                                        setPageLength={this.updateRecordsPerPage}
                                                                    />
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                        </div>

                    </div >
                </section >
                {/* <Footer /> */}

            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, get_roleList_action, delete_role_action })(roleList));
